import { render, staticRenderFns } from "./ModalABMPost.vue?vue&type=template&id=05a8273a&scoped=true&"
import script from "./ModalABMPost.vue?vue&type=script&lang=js&"
export * from "./ModalABMPost.vue?vue&type=script&lang=js&"
import style0 from "./ModalABMPost.vue?vue&type=style&index=0&id=05a8273a&lang=scss&scoped=true&"
import style1 from "./ModalABMPost.vue?vue&type=style&index=1&id=05a8273a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8273a",
  null
  
)

export default component.exports